import { render, staticRenderFns } from "./PurchaseBrowse.vue?vue&type=template&id=46a6782f&scoped=true"
import script from "./PurchaseBrowse.vue?vue&type=script&lang=ts"
export * from "./PurchaseBrowse.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseBrowse.vue?vue&type=style&index=0&id=46a6782f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a6782f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a6782f')) {
      api.createRecord('46a6782f', component.options)
    } else {
      api.reload('46a6782f', component.options)
    }
    module.hot.accept("./PurchaseBrowse.vue?vue&type=template&id=46a6782f&scoped=true", function () {
      api.rerender('46a6782f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchase/PurchaseBrowse.vue"
export default component.exports